<template>
  <div>
    <Header :title="$t('cskh.title')" />
    <div class="full-page-box">
      <div class="img-box">
        <img src="../../assets/imgs/cksh/top.png" />
      </div>
      <div class="desc">
        <p style="font-size: 24px;">{{ $t("cskh.desc") }}</p>
        <p>{{ $t("cskh.time") }}</p>
        <p style="color: rgb(4 109 181);text-decoration: underline ;" @click="toservice">{{ $t("cskh.btn") }}</p>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/footer/index.vue";
import Header from "@/components/header/index.vue";
import { Toast } from "vant";
export default {
  name: "CSKH",
  components: { Footer, Header },
  data(){
    return {
        onlineservice:null
    }
  },
  created(){
    this.getSetting()
  },
  methods:{
    getSetting() {
      this.$http({
        method: "get",
        url: "getloansetting",
      }).then((res) => {
        if (res.code == 200) {
          if (res.data && res.data.iskefu == 1) {
            this.onlineservice = res.data.kefu
          }
        } else {
          Toast(res.msg);
        }
      });
    },
    toservice () {
      const that = this
      const timeoutId = setTimeout(
        () => {
          window.open(that.onlineservice, '_blank')
          clearTimeout(timeoutId)
        },
        0
      )
    },
  }
};
</script>
<style scoped>
.img-box {
  width: 96%;
  margin: 10px auto;
}
.img-box img {
  width: 100%;
  border-radius: 8px;
}
.desc{
    text-align: center;
    line-height: 3;
}
</style>
